import { defineComponent as Z, openBlock as o, createElementBlock as e, mergeProps as d, unref as a, renderSlot as m, createElementVNode as n, createCommentVNode as p } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, h = { key: 1 }, A = { key: 2 }, g = { key: 3 }, M = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconDoorOpen"
}, _ = /* @__PURE__ */ Z({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const r = l, { bind: V, weight: H } = i(r);
    return (s, t) => (o(), e("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(V)), [
      m(s.$slots, "default"),
      a(H) === "bold" ? (o(), e("g", u, t[0] || (t[0] = [
        n("path", { d: "M232,212H212V40a20,20,0,0,0-20-20H64A20,20,0,0,0,44,40V212H24a12,12,0,0,0,0,24H232a12,12,0,0,0,0-24Zm-44,0H172V44h16ZM68,44h80V212H68Zm68,84a16,16,0,1,1-16-16A16,16,0,0,1,136,128Z" }, null, -1)
      ]))) : a(H) === "duotone" ? (o(), e("g", h, t[1] || (t[1] = [
        n("path", {
          d: "M200,40V224H168V32h24A8,8,0,0,1,200,40Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-40,0H176V40h16ZM64,40h96V216H64Zm80,92a12,12,0,1,1-12-12A12,12,0,0,1,144,132Z" }, null, -1)
      ]))) : a(H) === "fill" ? (o(), e("g", A, t[2] || (t[2] = [
        n("path", { d: "M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-64,0H64V40H168Zm-40-84a12,12,0,1,1,12,12A12,12,0,0,1,128,132Z" }, null, -1)
      ]))) : a(H) === "light" ? (o(), e("g", g, t[3] || (t[3] = [
        n("path", { d: "M232,218H206V40a14,14,0,0,0-14-14H64A14,14,0,0,0,50,40V218H24a6,6,0,0,0,0,12H232a6,6,0,0,0,0-12ZM194,40V218H174V38h18A2,2,0,0,1,194,40ZM62,40a2,2,0,0,1,2-2h98V218H62Zm80,92a10,10,0,1,1-10-10A10,10,0,0,1,142,132Z" }, null, -1)
      ]))) : a(H) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        n("path", { d: "M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-40,0H176V40h16ZM64,40h96V216H64Zm80,92a12,12,0,1,1-12-12A12,12,0,0,1,144,132Z" }, null, -1)
      ]))) : a(H) === "thin" ? (o(), e("g", f, t[5] || (t[5] = [
        n("path", { d: "M232,220H204V40a12,12,0,0,0-12-12H64A12,12,0,0,0,52,40V220H24a4,4,0,0,0,0,8H232a4,4,0,0,0,0-8ZM196,40V220H172V36h20A4,4,0,0,1,196,40ZM60,40a4,4,0,0,1,4-4H164V220H60Zm80,92a8,8,0,1,1-8-8A8,8,0,0,1,140,132Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  _ as default
};
